<template>
    <div class="text-center mt-5">
        <template v-if="showPages">
            <div class="row mb-5">
                <div class="col-6 offset-3">
                    <div class="d-flex align-items-center flex-column">
                        <div class="page_names">
                            <button v-for="(page, i) in value.pages" :key="i" @click="selectPage(i)" :disabled="$evaluate.eval(page.disabled) && !create" class="page_name" :class="{'actual_page_name': i == selectedPage}">
                                {{ page.name }}
                            </button>
                        </div>
                        <div class="slider mt-2">
                            <div class="slider_inner" :style="{'width': sliderWidth}">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="d-flex justify-content-end">
                        <Switch v-model="value.usage" :edit="edit"/>
                    </div>
                </div>
            </div>
        </template>
        <div ref="page" class="mt-3 row justify-content-center aling-items-center">
            <div class="text-center col-6">
                <Structure v-model="value.pages[selectedPage]" :edit="edit" :create="create"/>
            </div>
        </div>
        <div class="mt-5 d-flex align-items-center flex-column">
            <template v-if="showPages">
                <div class="switch mb-3">
                    <button
                        class="me-2"
                        :disabled="selectedPage == 0 || ($evaluate.eval(value.pages[selectedPage - 1].disabled) && !create)"
                        @click="selectPage(selectedPage - 1)"
                    >
                        {{ $t("utils.previousPage") }}
                    </button>
                    <button
                        class="switch_positive"
                        :disabled="selectedPage == (value.pages.length - 1) || ($evaluate.eval(value.pages[selectedPage + 1].disabled) && !create)"
                        @click="selectPage(selectedPage + 1)"
                    >
                        {{ $t("utils.nextPage") }}
                    </button>
                </div>
                <div class="page_points">
                    <button v-for="(page, i) in value.pages" :key="i" @click="selectPage(i)" :disabled="$evaluate.eval(page.disabled) && !create" class="page_point" :class="{'actual_page_point': i == selectedPage}"></button>
                </div>
                <!-- <div class="mt-3" v-if="$evaluate.eval(value.pages[selectedPage].printable)">
                    <button @click="downloadPage" class="downloadButton">
                        <icon icon="FileDownload"/>
                        {{ $t("utils.downloadPdf") }}
                    </button>
                </div> -->
                <div v-if="create" class="mt-3">
                    <button class="btn btn-primary" @click="addPage" :disabled="$evaluate.eval(value.disabled)">{{ $t("template.addPage") }}</button>
                </div>
            </template>
        </div>
        <!-- <ProductSummaryWhole/> -->
    </div>
</template>

<script>
import Structure from "@/components/Structure.vue";
import Switch  from "@/components/calculations/Switch.vue";
import ProductSummaryWhole from "@/components/calculations/ProductSummaryWhole.vue";

export default {
    components: {
        Structure,
        ProductSummaryWhole,
        Switch
    },
    props: {
        modelValue: {},
        edit: {
            type: Boolean,
            required: false,
            default: false
        },
        create: {
            type: Boolean,
            required: false,
            default: false
        },
        showPages: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    emits: ['update:modelValue', "select-page"],
    data() {
        return {
            selectedPage: 0,
        }
    },
    created: function () {
        this.$store.commit("updateTemplate", this.value);
    },
    watch: {
        value: {
            handler: function () {
                this.$store.commit("updateTemplate", this.value);
            },
            deep: true,
            intermediate: true
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        sliderWidth: function () {
            var length = this.value.pages.length;
            var active = length;
            for (var i = 0; i < length; i++){
                if (this.$evaluate.eval(this.value.pages[i].disabled)) {
                    active--;
                }
            }
            return ((active/length)*100) + "%";
        }
    },
    methods: {
        createID: function () {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
            }
            return result;
        },
        selectPage: function (number) {
            this.selectedPage = number;
            this.$emit("select-page", this.selectedPage);
        },
        addPage: function () {
            this.value.pages.push({
                "disabled": false,
                "printable": true,
                "id": this.createID(18),
                "structure": [
                    {
                        "component": "H1",
                        "text": "Nadpis",
                        "id": this.createID(18),
                        "class": null,
                        "style": null,
                        "type": null,
                        "calculate": null,
                        "units": null,
                        "hide": false,
                        "disabled": null,
                        "value": null,
                        "structure": [],
                    },
                ]
            })
            this.selectPage(this.value.pages.length - 1);
        },
        downloadPage: function () {
            var prtContent = this.$refs.page;
            console.log($(prtContent).clone());
            var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write('<html><head>');
            WinPrint.document.write('<link rel="stylesheet" href="index.css">');
            WinPrint.document.write('<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossorigin="anonymous">');
            WinPrint.document.write('</head><body>');
            console.log(prtContent.cloneNode(true));
            WinPrint.document.write($('<div>').append($(prtContent).clone()).html());
            WinPrint.document.write('</body></html>');
            WinPrint.document.close();
            WinPrint.focus();
        }
    }
}
</script>
<style lang="scss">
</style>